import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import { Fab } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
//
import UserFormDialog from './UserFormDialog';

const UsersFab:FC = () => {
  const { t } = useTranslation();

  const { open, toggle } = useToggle();
  const { isSuspended } = useAccountStatus();

  return (
    <Fragment>
      <Fab
        name="Create user"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16
        }}
        onClick={toggle}
        color="primary"
        variant="extended"
        disabled={isSuspended}
      >{t('pages.users.createButton')}</Fab>
      {/* Dialog */}
      {open ? (
        <UserFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default UsersFab;
